module.exports = __webpack_public_path__ + "phone.png?17a1642c77d9bb9d6c6803c8c2a3f2aa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone.png
// module id = 85
// module chunks = 0